import React from 'react'

export default function Footer() {
  return (
    <footer className="page-footer lg-black dark-blue darken-1">
         <br></br>
         <br></br>
         <div className="container medium center">
               <a className="grey-text text-lighten-4 tiny" href="https://propaganda.world"> © 2018 Propaganda World - Website & Application Developers Team</a>
        </div>
        <br></br>
        <div className="container medium center">
           <a  className="grey-text text-lighten-4 tiny" href="mailto:support@propaganda.world"> Contact </a> | <a  className="grey-text text-lighten-4 tiny" href="/privacy"> Privacy </a> | <a className="grey-text text-lighten-4 tiny" href="/terms-and-conditions"> Terms </a>     
        </div>
        <br></br>
        <br></br>
         
       </footer>
  )
}
